import React from 'react';
import LocationTemplate from './LocationTemplate';

const LaGrangePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="La Grange"
      stateName="North Carolina"
      countyName="Lenoir"
      zipCodes={["28551"]}
      latitude={35.3057}
      longitude={-77.79}
      population={2800}
      historicalFact="Named after the French estate of the Marquis de Lafayette, who toured the area in 1825."
      nearbyTowns={[
        "Kinston, NC",
        "Goldsboro, NC",
        "Seven Springs, NC",
        "Pink Hill, NC",
        "Deep Run, NC",
        "Mount Olive, NC",
        "Pikeville, NC",
        "Grifton, NC"
      ]}
    />
  );
};

export default LaGrangePage;